import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';

const steps = [
  'Course Details',
  'Upload Course Content',
  'Upload Questionnaire',
];

export default function StepperComponent({ stepperCount,propsSteps }) {
  const rendringSteps=propsSteps&&propsSteps.length>0?propsSteps:steps;
  return (
    <Box sx={{ width: '100%' }}>
      <Stepper activeStep={stepperCount} alternativeLabel>
        {rendringSteps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}